




































































































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import FieldMap from '@/app/components/Field/FieldMap.vue'
/* api */
import MasterFieldListApi from '@/app/model/api/masterFieldListApi'
/* module */
import { gmapApi } from 'vue2-google-maps'
import CommonClass from '@/app/module/common'
import Session from '@/app/module/session'

@Component({
  components: {
    Loading,
    FieldMap
  }
})
export default class FieldSectionSettingModal extends Vue {
  private displayPolygon: {[key:string]: string|number|any} = []
  private displayMaker: {[key:string]: string|number|any} = []
  private polygons: {[key:string]: string|number|any} = []
  private basicData: {[key:string]: string|any} = {
    position: {
      lat: 36.00000,
      lng: 138.00000
    },
    zoom: 5,
    mapType: 'satellite'
  }
  private drawingManager: any = []
  private editPolygon: any = []
  private newPolygon: any = []
  private newPolygonFlag: boolean = true
  private firstFlag: boolean = true
  private showExistingFieldPolygon = false
  private gettingFieldList = false
  private bounds: any = []
  private area: number = 0
  private centerPath: any = {}
  private polygonDetail: any = {}
  private addressErrorMessage: string = ''
  private address: string = ''
  private searchCenterPosition: null|{[key:string]: number} = null

  @Prop() private isShow!: boolean
  @Prop() private polygonData!: any

  private polygonOptions: {[key:string]: string|number|boolean} = {
    strokeColor: '#FF3535',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF3535',
    fillOpacity: 0.35,
    clickable: true,
    draggable: true,
    editable: true,
    zIndex: 1
  }
  private yellowMaker: any = {
    url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
    size: { width: 50, height: 50, f: 'px', b: 'px' },
    scaledSize: { width: 50, height: 50, f: 'px', b: 'px' }
  }

  /* computed */
  @Watch('isShow')
  drawingPolygon (flag: boolean) {
    if (flag) {
      if (this.polygonData.centerLatLng.lat !== null &&
       this.polygonData.centerLatLng.lng !== null &&
        this.polygonData.centerLatLng.lat !== 0 &&
        this.polygonData.centerLatLng.lng !== 0) {
        this.basicData.position = this.polygonData.centerLatLng
        this.basicData.zoom = 18
      } else {
        this.basicData.position = { lat: 36.00000, lng: 138.00000 }
        this.basicData.zoom = 5
      }
      this.polygonOptions.strokeColor = this.polygonData.polygonColor
      this.polygonOptions.fillColor = this.polygonData.polygonColor

      if (this.area !== 0) {
        this.deleteSelectedShape()
        this.drawingManager.setDrawingMode(null)
      }
      this.initMap()
    } else {
      this.searchCenterPosition = null
    }
  }

  @Watch('showExistingFieldPolygon')
  changeDisplayPolygon (flag: boolean) {
    if (flag) {
      const data = Session.getFieldPolygonData()
      if (data === undefined || data === null) {
        this.getFieldList()
        return
      }
      this.createPolygonMaker()
    } else {
      this.displayPolygon = []
      this.displayMaker = []
    }
  }

  private createPolygonMaker () {
    let polygons = []
    let maskers = []
    const fieldId = parseInt(this.$route.params.field_id)
    for (let i in this.polygons) {
      if (this.polygons[i].field_id !== fieldId) {
        if (this.polygons[i].polygon.length === 0) {
          maskers.push(this.polygons[i])
        } else {
          polygons.push(this.polygons[i])
        }
      }
    }
    this.displayPolygon = polygons
    this.displayMaker = maskers
  }

  private async getFieldList () {
    this.gettingFieldList = true
    const data = {
      word: '',
      sensor_word: '',
      order_name: 'created_at',
      sort: false,
      page: 1,
      include_polygon: 1
    }
    const result = await MasterFieldListApi.getMasterFieldList(data)

    if (result.isOk()) {
      this.polygons = result.getPayload().results
      Session.setFieldPolygonData(JSON.stringify(this.polygons))
      this.gettingFieldList = false
      this.createPolygonMaker()
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
    }
  }

  private getPolygonOption (color: string) {
    return {
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.35
    }
  }

  private async doSerchAddress () {
    this.addressErrorMessage = ''

    if (this.address === '') {
      this.addressErrorMessage = '住所、緯度経度を入力してください。'
      this.searchCenterPosition = null
      return
    }

    const map: any = this.$refs.map

    // 検索ワード=緯度経度
    const latlngArray = this.address.split(',')
    if (latlngArray.length === 2) {
      const lat = Number.parseFloat(latlngArray[0])
      const lng = Number.parseFloat(latlngArray[1])
      if (!isNaN(lat) && !isNaN(lng)) {
        // 緯度
        if (lat < -90 || lat > 90) {
          this.addressErrorMessage = '緯度は-90以上90以下の範囲で入力してください。'
        }
        // 緯度
        if (lng < -180 || lng > 180) {
          this.addressErrorMessage = '経度は-180以上180以下の範囲で入力してください。'
        }

        if (this.addressErrorMessage === '') {
          this.searchCenterPosition = {
            lat: lat,
            lng: lng
          }
          this.addressErrorMessage = ''
          map.$mapObject.setCenter(this.searchCenterPosition)
          map.$mapObject.setZoom(18)
        }
        return
      }
    }

    // 検索ワード=住所等
    const geocoder = new google.maps.Geocoder()
    const vueComponents: any = this
    await geocoder.geocode({ 'address': this.address }, function (results: any, status: any) {
      if (status === google.maps.GeocoderStatus.OK) {
        const position = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        }
        map.$mapObject.setCenter(position)
        map.$mapObject.setZoom(18)
        vueComponents.searchCenterPosition = position
        vueComponents.addressErrorMessage = ''
      } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
        vueComponents.addressErrorMessage = '該当する住所が見つかりませんでした。'
        vueComponents.searchCenterPosition = null
      } else {
        vueComponents.addressErrorMessage = '住所検索に失敗しました。'
        vueComponents.searchCenterPosition = null
      }
    })
  }

  private initMap () {
    let map: any = this.$refs.map
    if (this.firstFlag) {
      /* ポリゴンを描く */
      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        drawingControlOptions: {
          drawingModes: ['polygon', 'marker']
        },
        markerOptions: {
          draggable: false
        },
        polylineOptions: {
          editable: true,
          draggable: false
        },
        makerOptions: this.polygonOptions,
        polygonOptions: this.polygonOptions,
        map: map.$mapObject
      })
    }
    this.firstFlag = false

    /* ポリゴンを書き終わったときに発火 */
    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', function (this: any, e: any) {
      let newShape = e.overlay
      let path = newShape.getPath()

      /* 図形を描画した後、非描画モードに切り替え */
      this.setDrawingMode(null)
      /* センター・面積・緯度経度取得 */
      this.newPolygon = newShape
      return this.newPolygon
    })

    /* polygonPathがあるならポリゴンを描画 */
    if (this.polygonData.polygonPath.length !== 0) {
      this.newPolygonFlag = false
      /* ポリゴン新規描画機能OFF */
      this.drawingManager.setDrawingMode(null)

      let drawPolygon = new google.maps.Polygon({
        paths: this.polygonData.polygonPath,
        strokeColor: '#FF3535',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF3535',
        fillOpacity: 0.35,
        editable: true
      })
      drawPolygon.setMap(map.$mapObject)

      let editPolygon: any
      this.editPolygon = drawPolygon

      drawPolygon.getPaths().forEach(function (path: any, index: any) {
        editPolygon = drawPolygon

        // ポリゴン変更一回目
        google.maps.event.addListener(path, 'insert_at', function (this: any) {
          return editPolygon
        })

        // ポリゴン変更一回目の変更取り消し
        google.maps.event.addListener(path, 'remove_at', function (this: any) {
          return editPolygon
        })

        // ポリゴン変更二回目以降
        google.maps.event.addListener(path, 'set_at', function (this: any) {
          return editPolygon
        })

        return editPolygon
      })
    } else {
      this.newPolygonFlag = true
      /* ポリゴン新規描画機能ON */
      this.drawingManager.setDrawingMode('polygon')
    }
  }

  /* ポリゴンをリセット */
  private deleteSelectedShape () {
    if (this.newPolygonFlag && this.drawingManager.newPolygon !== undefined) {
      this.newPolygon = this.drawingManager.newPolygon
      this.newPolygon.setMap(null)
    } else if (!this.newPolygonFlag) {
      this.editPolygon.setMap(null)
      this.newPolygonFlag = true
    }

    this.bounds = []
    this.drawingManager.setDrawingMode('polygon')
  }

  private savePolygon () {
    /* ポリゴンの中心座標を取得 */
    let vertices
    let lowx
    let highx
    let lowy
    let highy
    let lats = []
    let lngs = []

    if (this.newPolygonFlag) {
      if (this.drawingManager.drawingMode === null) {
        this.newPolygon = this.drawingManager.newPolygon
        vertices = this.newPolygon.getPath()
      } else {
        this.area = 0
        this.bounds = []
        this.centerPath = {
          lat: null,
          lng: null
        }
        this.polygonDetail = {
          centerPath: this.centerPath,
          polygonPath: this.bounds,
          area: this.area
        }
        this.addressErrorMessage = ''
        this.address = ''
        this.$emit('setting-polygon', this.polygonDetail)
        return
      }
    } else {
      vertices = this.editPolygon.getPath()
    }

    for (let i = 0; i < vertices.length; i++) {
      lats.push(vertices.getAt(i).lat())
      lngs.push(vertices.getAt(i).lng())
    }

    lats.sort()
    lngs.sort()
    lowx = lats[0]
    highx = lats[vertices.length - 1]
    lowy = lngs[0]
    highy = lngs[vertices.length - 1]
    let center_x = lowx + ((highx - lowx) / 2)
    let center_y = lowy + ((highy - lowy) / 2)

    this.centerPath = { lat: center_x, lng: center_y }

    /* ポリゴンの緯度経度 */
    let lat
    let lng
    let vertice
    this.bounds = []

    if (this.newPolygonFlag) {
      vertice = this.newPolygon.getPath()
    } else {
      vertice = this.editPolygon.getPath()
    }

    for (let i = 0; i < vertice.length; i++) {
      lat = vertice.getAt(i).lat()
      lng = vertice.getAt(i).lng()

      this.bounds.push({ lat, lng })
    }

    /* ポリゴン面積取得 */
    if (this.newPolygonFlag) {
      this.area = google.maps.geometry.spherical.computeArea(this.newPolygon.getPath())
    } else {
      this.area = google.maps.geometry.spherical.computeArea(this.editPolygon.getPath())
    }

    this.polygonDetail = {
      centerPath: this.centerPath,
      polygonPath: this.bounds,
      area: this.area
    }
    this.addressErrorMessage = ''
    this.address = ''
    this.$emit('setting-polygon', this.polygonDetail)
  }

  private doCancel () {
    this.basicData.position = { lat: 36.00000, lng: 138.00000 }
    if (this.newPolygon.length !== 0 || this.editPolygon.length !== 0) {
      this.deleteSelectedShape()
    }
    this.drawingManager.setDrawingMode(null)
    this.addressErrorMessage = ''
    this.address = ''
    this.$emit('close-modal')
  }
}
